var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getComponent,{tag:"component",attrs:{"component":_vm.component.item,"is-active":_vm.isActive}})
}
var staticRenderFns = []

export { render, staticRenderFns }